import { Quote } from '@prisma/client';
import { useMemo } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';

const getKey = (quote: Quote) => `bookingState-${quote.request_id}-${quote.provider_id}`;

export const useBookingStateSetter = (quote: Quote, methods: UseFormReturn<any, any, any>) => {
  const value = useWatch({
    control: methods.control,
  });
  sessionStorage.setItem(getKey(quote), JSON.stringify(value));
};

export const useBookingState = (quote: Quote) => {
  const initialState = useMemo(() => {
    return JSON.parse(sessionStorage.getItem(getKey(quote)) ?? '{}');
  }, [quote]);
  return initialState;
};
